module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/onesence-4-d3db6e8e21e942a2168db65b860e7922.webp";